import { useAffiliateStore } from '@/stores/AffiliateStore'
import { useAuthSiteStore } from '@/stores/AuthStore'
import { useCartStore } from '@/stores/CartStore'

export const AuthAffiliateGuard = (to, from, next) => {
  const authStore = useAuthSiteStore()

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/afiliado/login')
  } else if (to.meta.requiresAuth && authStore.isAuthenticated && !authStore.isAffiliate) {
    next('/seja-afiliado')
  } else {
    next()
  }
}

export const LoginAffiliateGuard = (to, from, next) => {
  const authStore = useAuthSiteStore()

  if (!authStore.isAuthenticated) {
    next()
  } else {
    next('/afiliado/portal/dashboard')
  }
}


export const LojaAffiliateGuard = async (to, from, next) => {
  const authStore = useAuthSiteStore()
  const affiliteStore = useAffiliateStore()
  const carStore = useCartStore()

  await affiliteStore.GetAffiliate(to.params.code)

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/afiliado/loja/login')
  } else {
    carStore.SetAffiliateCode(to.params.code)
    next()
  }

}
